export default "__VITE_ASSET__YrT5ZDpq__"